"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "urbania": {
    "da666beb": [{
      "hkey": "cb8d8f72",
      "slug": "muraglione-ca-serafino",
      "name": "Muraglione-Ca' Serafino",
      "primary": true,
      "skipSearch": false
    }],
    "muraglione": [{
      "hkey": "cb8d8f72",
      "slug": "muraglione-ca-serafino",
      "name": "Muraglione-Ca' Serafino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;